import {
  SET_ANNOUNCEMENT_COUNT,
  SET_ANNOUNCEMENT_CURRENT,
  SET_ANNOUNCEMENT_LIST,
  SET_ANNOUNCEMENT_LOADING,
} from "./types";
import { BACKEND_URL_PREFIX } from "../utils/const";
import { buildDefaultHeaders } from "./helper";
import { checkAndUpdateToken } from "./auth";

const fetchWithAuth = async (url, getState) => {
  const response = await fetch(url, buildDefaultHeaders(getState));
  if (!response.ok) {
    throw new Error(`HTTP error: ${response.status}`);
  }
  return response.json();
};

export const getCount = () => async (dispatch, getState) => {
  try {
    await dispatch(checkAndUpdateToken());
    if (!getState().auth.token) return;

    const payload = await fetchWithAuth(
      `${BACKEND_URL_PREFIX}/announcement/how_unread_announcement`,
      getState
    );
    dispatch({ type: SET_ANNOUNCEMENT_COUNT, payload });
  } catch (error) {
    console.error("Failed to get announcement count:", error);
  }
};

export const getList = () => async (dispatch, getState) => {
  dispatch({ type: SET_ANNOUNCEMENT_LOADING, payload: true });
  try {
    await dispatch(checkAndUpdateToken());
    if (!getState().auth.token) return;

    const payload = await fetchWithAuth(
      `${BACKEND_URL_PREFIX}/announcement`,
      getState
    );
    dispatch({ type: SET_ANNOUNCEMENT_LIST, payload });
  } catch (error) {
    console.error("Failed to get announcement list:", error);
  } finally {
    dispatch({ type: SET_ANNOUNCEMENT_LOADING, payload: false });
  }
};

export const getCurrent = (id) => async (dispatch, getState) => {
  dispatch({ type: SET_ANNOUNCEMENT_LOADING, payload: true });
  try {
    await dispatch(checkAndUpdateToken());
    if (!getState().auth.token) return;

    const payload = await fetchWithAuth(
      `${BACKEND_URL_PREFIX}/announcement/${id}`,
      getState
    );
    dispatch({ type: SET_ANNOUNCEMENT_CURRENT, payload });
  } catch (error) {
    console.error("Failed to get current announcement:", error);
  } finally {
    dispatch({ type: SET_ANNOUNCEMENT_LOADING, payload: false });
  }
};

export const getCurrentFiles = (id) => async (dispatch, getState) => {
  try {
    await dispatch(checkAndUpdateToken());
    if (!getState().auth.token) return null;

    const response = await fetch(
      `${BACKEND_URL_PREFIX}/announcement/${id}/file`,
      buildDefaultHeaders(getState)
    );
    if (!response.ok) {
      throw new Error(`HTTP error: ${response.status}`);
    }
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error("Failed to get announcement files:", error);
    return null;
  }
};

export const getCurrentChapterFiles = (announcementId, chapterId) => async (dispatch, getState) => {
  try {
    await dispatch(checkAndUpdateToken());
    if (!getState().auth.token) return null;

    const response = await fetch(
      `${BACKEND_URL_PREFIX}/announcement/${announcementId}/file/${chapterId}`,
      buildDefaultHeaders(getState)
    );
    if (!response.ok) {
      throw new Error(`HTTP error: ${response.status}`);
    }
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error("Failed to get chapter files:", error);
    return null;
  }
};
